import { render, staticRenderFns } from "./GeneralDataStep.vue?vue&type=template&id=facc524a"
import script from "./GeneralDataStep.vue?vue&type=script&lang=js"
export * from "./GeneralDataStep.vue?vue&type=script&lang=js"
import style0 from "./GeneralDataStep.vue?vue&type=style&index=0&id=facc524a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports